import latihanIlmiahApi from '@/services/latihanIlmiah/latihanIlmiahApi'

const state = {
    exists: false,
    registrations: [],
    details: {},   // { [registrationHash]: detail }
}

const getters = {
    // registration ล่าสุด (API เรียง attempt DESC แล้ว)
    latest: state => state.registrations[0] || null,
    previous: state => state.registrations.slice(1),
}

const mutations = {
    SET_EXISTS(state, exists) {
        state.exists = exists
    },
    SET_REGISTRATIONS(state, registrations) {
        state.registrations = registrations
    },
    SET_DETAIL(state, detail) {
        state.details = { ...state.details, [detail.id]: detail }
    },
}

const actions = {
    async fetchExists({ commit }) {
        const exists = await latihanIlmiahApi.fetchExists()
        commit('SET_EXISTS', exists)
        return exists
    },

    async fetchRegistrations({ commit }) {
        const registrations = await latihanIlmiahApi.fetchRegistrations()
        commit('SET_REGISTRATIONS', registrations)   // commit ก่อน return
        return registrations
    },

    async fetchRegistration({ commit }, id) {
        const detail = await latihanIlmiahApi.fetchRegistration(id)
        commit('SET_DETAIL', detail)
        return detail
    },

    // หลังอัปโหลด/ลบ โหลด detail ใหม่ให้รายการไฟล์ตรงกับ server
    async uploadFile({ dispatch }, { id, file, note }) {
        await latihanIlmiahApi.uploadFile(id, file, note)
        return dispatch('fetchRegistration', id)
    },

    async deleteFile({ dispatch }, { id, fileId }) {
        await latihanIlmiahApi.deleteFile(id, fileId)
        return dispatch('fetchRegistration', id)
    },

    downloadFile(_ctx, { id, fileId }) {
        return latihanIlmiahApi.downloadFile(id, fileId)
    },
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
}
